import {t} from 'i18next';
import React from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import PresentationView from '../../../components/presentationView/PresentationView';
import {useDebouncePresentationState} from '../../../hooks/useDebouncePresentationState';
import {useLayout} from '../../../hooks/useLayout';
import {useWarnBeforeUnload} from '../../../hooks/useWarnBeforeUnload';
import BaseLayout from '../../layout/BaseLayout';
import {desktopViewSelector} from '../../../store/selectors/layout.selectors';
import {loadedPresentationSelector} from '../../../store/selectors/presentation.selectors';

function PlayPage(): JSX.Element {
    const isDesktopViewSelected = useSelector(desktopViewSelector);
    const loadedPres = useSelector(loadedPresentationSelector);
    const debouncePresentationState = useDebouncePresentationState();
    const {mobileView} = useLayout();
    useWarnBeforeUnload(!!loadedPres);

    if (!loadedPres) return <></>;

    return (
        <BaseLayout hasPresActions>
            <>
                <div className={`p-player ${isDesktopViewSelected ? 'p-player--desktop' : ''}`} data-cy="player_page">
                    <ErrorBoundary
                        resetKeys={[mobileView]}
                        FallbackComponent={() => {
                            toast.warning(t('playerPage.warning'), {toastId: 'player-warning'});
                            return null;
                        }}
                        onError={() => debouncePresentationState()}
                    >
                        <PresentationView />
                    </ErrorBoundary>
                </div>
            </>
        </BaseLayout>
    );
}

export default PlayPage;
